:host {
  display: flex;
  border: var(--Common--border);
  border-color: var(--theme-button-border);
  border-radius: var(--aha-visual-selection--border-radius, calc(var(--Common--border-radius) * 2));
  padding: var(--spacer-3) var(--spacer-4);
  margin-bottom: var(--spacer-4);
  cursor: pointer;
  background-color: var(--aha-visual-selection--background-color, var(--theme-tertiary-background));
}

:host(.visual-selection__vertical) {
  flex-direction: column;
  align-items: center;
  padding: var(--spacer-3) var(--spacer-7);
}
:host(:hover:not([disabled])) {
  background-color: var(--theme-list-item-hover-background);
  outline: 2px solid var(--aha-blue-400);
  border: 1px solid transparent;
}

:host(:is([selected]):not([disabled])) {
  outline: 2px solid var(--aha-visual-selection--border-color-selected, var(--aha-blue-400));
  background-color: var(--theme-list-item-active-background);
  border: 1px solid transparent;
}

:host(:hover:not([disabled])) .image,
:host(:is([selected])) .image {
  filter: none;
}

:host([align-image='center']) .visual-selection__image-container {
  justify-content: center;
}

:host([align-image='top']) .visual-selection__image-container {
  justify-content: top;
}

.image {
  height: var(--aha-visual-selection--image-height, 50px);
  width: var(--aha-visual-selection--image-width, 50px);
  border-radius: var(--Common--border-radius);
  filter: grayscale(100%);
}

.multiple-images > .image {
  filter: none;
}

.multiple-images {
  display: flex;
}

.image--selected {
  display: none;
}

:host(:hover:not([disabled])) .image--not-selected,
:host(:is([selected])) .image--not-selected {
  display: none;
}

:host(:hover) .image--selected,
:host(:is([selected])) .image--selected {
  display: inline;
}

:host(.visual-selection__vertical) .visual-selection__description {
  align-items: center;
}

.visual-selection__image-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--aha-visual-selection--image-padding, none);
}

:host(.visual-selection__horizontal) .visual-selection__image-container {
  margin-right: var(--spacer-4);
}

:host(.visual-selection__vertical) .visual-selection__image-container {
  margin-bottom: var(--spacer-2);
}

.visual-selection__description {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
}

:host(.visual-selection__vertical) .visual-selection__description {
  text-align: center;
  margin-bottom: 0;
}

.visual-selection__description-title {
  padding-top: var(--spacer-1);
}

.visual-selection__description-text {
  padding-top: var(--spacer-05);
}

.visual-selection__icon {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
